export class AnimateEvent {
    static CREATED = 'created'

    static PLAY = 'play'
    static PAUSE = 'pause'
    static STOP = 'stop'
    static SEEK = 'seek'

    static UPDATE = 'update'
    static COMPLETED = 'completed'
}
